"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WafContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _internals = require("../../internals");
var _ErrorButton = require("../ErrorButton");
var _PageHeader = require("../PageHeader");
var _SupportId = require("../SupportId");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const WafContent = ({
  contactSupportTeamText,
  errorCode,
  headerText,
  messageText,
  errorButtonText
}) => {
  // Support ID from query - used by WAF
  const supportId = (0, _react.useRef)((0, _internals.getUrlQueryParam)('support-id'));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PageHeader.PageHeader, {
      errorCode: errorCode,
      headerText: headerText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: messageText
    }), supportId.current ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      children: [contactSupportTeamText, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledLink, {
        href: `mailto:ServiceDesk@oriflame.com?Subject=SupportID:${supportId.current}`,
        children: "ServiceDesk@oriflame.com"
      })]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorButton.ErrorButton, {
      text: errorButtonText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SupportId.SupportId, {
      supportId: supportId.current
    })]
  });
};
exports.WafContent = WafContent;
